import Base from '../Pages/Base'
import List from '../Pages/List'
import Form from '../Pages/Form'

export default [
	{
		path: 'site/gestoes',
		component: Base,
		children: [
			{
				path: '',
				name: 'GestoesList',
				component: List,
				meta: {
					path: '/site/gestoes',
					pai: 'Site',
					title: 'Admin - Gestões',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Gestões',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			{
				path: 'novo',
				name: 'GestoesNovo',
				component: Form,
				meta: {
					path: '/site/gestoes',
					pai: 'Site',
					title: 'Admin - Gestões - Novo',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Gestões',
						class: '',
						active: false,
						url: '/site/gestoes'
					},
					{
						pagina: 'Novo',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			{
				path: ':id',
				name: 'GestoesEditar',
				component: Form,
				meta: {
					path: '/site/gestoes',
					pai: 'Site',
					title: 'Admin - Gestões - Editar',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Gestões',
						class: '',
						active: false,
						url: '/site/gestoes'
					},
					{
						pagina: 'Editar',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			}
		]
	}
]